import KitchenHeader from './KitchenHeader';
import React from 'react';
import CustomTable from '../../../../components/table/CustomTable';
import KitchenHistoryTableApp from '../Functionality/KitchenHistoryTableApp';
import NotInformation from '../../../../components/NotInformation';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model history: model of header section
 * @param event onChange: Event to update the module in the header section
 * @param useState search: Variable for searching the items
 * @param useState setSearch: State to update the search variable for items
 * @param boolean activeStep: Variable to indicate which tab is active
 * @param boolean modified: Variable to indicate if data update is required
 * @param useState setModified: Variable to update the status
 *
 */
const KitchenHistory = ({history, onChange, search, setSearch, activeStep, modified, setModified, setSimpleSearch}) => {

    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        setBodyForExport,
        setResults,
        option,
        rowsPerPage,
        getData
    } = KitchenHistoryTableApp({
        history,
        searchElement: search,
        setSearchElement: setSearch,
        activeStep,
        modified,
        setModified
    });

    return (<>
        <KitchenHeader
            item={history}
            handleChange={onChange}
            search={search}
            setSearch={setSearch}
            activeStep={activeStep}
            searchId={searchId}
            setBodyForExport={setBodyForExport}
            setResults={setResults}
            option={option}
            rowsPerPage={rowsPerPage}
            setSimpleSearch={setSimpleSearch}
            getData={getData}
        />

        {tbody?.data?.length > 0
            ?
            <>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                />

                {pagination()}
            </>
            :
            <NotInformation card={true} text={t("no_completed_orders_for_this_date")}/>
        }
    </>)

}

export default KitchenHistory
